import { useState } from "react";
import withLoader from "./../../../components/layouts/WithLoader";
import SellingService from "../../../services/SellingService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { Snackbar, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import DataTableBordereau from "./DataTableBordereau";

const ListBordereau = ({ startLoading, stopLoading }) => {
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [listBordereau, setListBordereau] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const onChangeDateBegin = (event) => {
    const selectedValue = event.target.value;

    // Check if the selected value includes a time part
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // If time exists, append ":00" to set seconds to 00
      : selectedValue + "T00:00:00"; // If it's a date-only input, append "T00:00:00" for the first second of the day

    console.log("Updated Date Begin:", updatedValue);
    setDateBegin(updatedValue);
  };

  const onChangeDateEnd = (event) => {
    const selectedValue = event.target.value;

    // Check if the selected value includes a time part
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // If time exists, append ":00" to set seconds to 00
      : selectedValue + "T23:59:59"; // If it's a date-only input, append "T23:59:59" for the last second of the day

    setDateEnd(updatedValue);
  };


  const onGetDocumentsByFilter = () => {
    setListBordereau([]);
    startLoading();
    SellingService.getListBordereauByUserAndDates(
      getCurrentUserId(),
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (response.data.vide) {
        } else if (response.data.success) {
          setListBordereau(response.data.success);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="datetime-local"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="datetime-local"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetDocumentsByFilter}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
              {listBordereau.length > 0 && (
                <DataTableBordereau listBordereau={listBordereau} />
              )}
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ListBordereau);
